import { Transforms } from "slate";
export var insertHorizontal = function (editor) {
    var text = { text: "" };
    var horizontal = { type: "horizontal", children: [text] };
    Transforms.insertNodes(editor, horizontal);
};
